import { render, staticRenderFns } from "./ContactModuleRulesRuleAdded.vue?vue&type=template&id=20bfa67d&scoped=true"
import script from "./ContactModuleRulesRuleAdded.vue?vue&type=script&lang=js"
export * from "./ContactModuleRulesRuleAdded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bfa67d",
  null
  
)

export default component.exports